// de_pms_common.ts
// Elementy wspólne dla wszystkich ekranów PMS — statusy, akcje, etykiety
// Importuj ten plik w każdym ekranowym pliku tłumaczeń zamiast powielać te same klucze.

export const dePmsCommon = {

  emptyValue: "—",
  yes: "Ja",
  no: "Nein",

  roomWithNumber: "Zimmer {{number}}",
  counts: {
    rooms_one: "{{count}} Zimmer",
    rooms_other: "{{count}} Zimmer",
    nights_one: "{{count}} Nacht",
    nights_other: "{{count}} Nächte",
    guests_one: "{{count}} Gast",
    guests_other: "{{count}} Gäste",
    adults_one: "{{count}} Erwachsener",
    adults_other: "{{count}} Erwachsene",
    children_one: "{{count}} Kind",
    children_other: "{{count}} Kinder",
  },

  navigation: {
    rooms: "Zimmer & Zimmertypen",
    "live-board": "Live Board",
    reservations: "Reservierungen",
    groups: "Gruppen & Kontingente",
    "room-type-availability": "Verfügbare Zimmertypen",
    "room-availability-calendar": "Zimmerkalender",
    guests: "Gäste",
    frontdesk: "Rezeption",
    housekeeping: "Housekeeping",
    billing: "Abrechnung",
    "night-audit": "Night Audit",
    rates: "Preise & Verfügbarkeit",
    channels: "Kanäle",
    interfaces: "Schnittstellen",
    reports: "Berichte",
  },
  sidebar: {
    dashboard: "Infoboard",
    openModule: "{{module}} öffnen",
    openExternal: "{{module}} öffnen (extern)",
    openExternalTitle: "{{module}} öffnen (extern, neuer Tab)",
    customize: "Navigation anpassen",
    expand: "Navigation ausklappen",
    collapse: "Navigation einklappen",
    show: "Navigation einblenden",
    hide: "Navigation ausblenden",
    description: "Module auswählen, anordnen und aufklappen, um ihre Unterbereiche anzupassen.",
    closeSettings: "Navigationseinstellungen schließen",
    subsections_one: "{{count}} Unterbereich",
    subsections_other: "{{count}} Unterbereiche",
    hideItem: "{{item}} ausblenden",
    showItem: "{{item}} einblenden",
    shown: "Sichtbar",
    hidden: "Ausgeblendet",
    moveItemUp: "{{item}} nach oben verschieben",
    moveItemDown: "{{item}} nach unten verschieben",
    moveUp: "Nach oben verschieben",
    moveDown: "Nach unten verschieben",
    reset: "Auf Standard zurücksetzen",
    done: "Fertig",
  },
  workspace: {
    identity: "Identitätsverwaltung",
    settings: "Einstellungen",
    language: "Sprache",
    languageOptions: "Sprachoptionen",
    active: "Aktiv",
    darkMode: "Dunkler Modus",
    logout: "Abmelden",
    newReservation: "Neue Reservierung",
    startCheckin: "Check-in starten",
  },

  // ── Statusy pokoi ──────────────────────────────────────────────────────────
  roomStatus: {
    available:    "Verfügbar",
    occupied:     "Belegt",
    dirty:        "Schmutzig",
    clean:        "Sauber",
    cleaning:     "In Reinigung",
    inspected:    "Geprüft",
    blocked:      "Gesperrt",
    outOfOrder:   "Außer Betrieb",
    outOfService: "Außer Service",
    unassigned:   "Nicht zugewiesen",
    reserved:     "Reserviert",
    maintenance:  "Wartung",
  },

  // ── Statusy rezerwacji ─────────────────────────────────────────────────────
  reservationStatus: {
    confirmed:  "Bestätigt",
    inHouse:    "Im Haus",
    cancelled:  "Storniert",
    checkedOut: "Abgereist",
    noShow:     "No-Show",
    waitlist:   "Warteliste",
    pending:    "Ausstehend",
    planned:    "Geplant",
    completed:  "Abgeschlossen",
    booked:     "Gebucht",
    active:     "Aktiv",
    all:        "Alle",
  },

  roomCalendar: {
    allTypes: "Alle Zimmertypen",
    allFloors: "Alle Etagen",
    floor: "Etage {{floor}}",
    filterByFloor: "Nach Etage filtern",
    clearFilters: "Zurücksetzen",
    checkedOut: "Ausgecheckt",
    checkedIn: "Eingecheckt",
    cancelledNoShow: "Storniert / Nicht angereist",
    showCheckedOut: "Ausgecheckte Reservierungen anzeigen",
    hideCheckedOut: "Ausgecheckte Reservierungen ausblenden",
    reservationLegend: "Legende der Reservierungsstatus und Zimmerfilter",
    roomNumberPlaceholder: "Zimmernr.",
    searchRoomNumber: "Nach Zimmernummer suchen",
  },

  // ── Ważność / Priorytet ────────────────────────────────────────────────────
  severity: {
    critical: "Kritisch",
    high:     "Hoch",
    medium:   "Mittel",
    low:      "Niedrig",
  },

  // ── Przyciski i akcje ──────────────────────────────────────────────────────
  actions: {
    save:        "Speichern",
    saving:      "Wird gespeichert...",
    cancel:      "Abbrechen",
    cancelling:  "Wird storniert...",
    close:       "Schließen",
    closing:     "Wird abgeschlossen...",
    edit:        "Bearbeiten",
    delete:      "Löschen",
    confirm:     "Bestätigen",
    approve:     "Genehmigen",
    create:      "Erstellen",
    creating:    "Wird erstellt...",
    add:         "Hinzufügen",
    adding:      "Hinzufügen...",
    back:        "Zurück",
    search:      "Suchen",
    filter:      "Filtern",
    refresh:     "Aktualisieren",
    download:    "Herunterladen",
    preview:     "Vorschau",
    print:       "Drucken",
    send:        "Senden",
    modify:      "Ändern",
    viewAll:     "Alle anzeigen",
    viewDetails: "Details anzeigen",
    opening:     "Wird geöffnet...",
    set:         "Setzen",
  },

  // ── Stany komunikatów ──────────────────────────────────────────────────────
  state: {
    loading:   "Wird geladen...",
    noData:    "Keine Daten",
    noResults: "Keine Ergebnisse",
    failed:    "Fehlgeschlagen.",
  },

  // ── Wspólne etykiety pól ───────────────────────────────────────────────────
  labels: {
    guest:        "Gast",
    guests:       "Gäste",
    room:         "Zimmer",
    rooms:        "Zimmer",
    floor:        "Etage",
    night:        "Nacht",
    nights:       "Nächte",
    checkIn:      "Check-in",
    checkOut:     "Check-out",
    arrival:      "Anreise",
    departure:    "Abreise",
    arrivals:     "Anreisen",
    departures:   "Abreisen",
    status:       "Status",
    operations:   "Betrieb",
    frontDesk:    "Rezeption",
    occupancy:    "Auslastung",
    revenue:      "Umsatz",
    billing:      "Abrechnung",
    housekeeping: "Housekeeping",
    department:   "Abteilung",
    owner:        "Verantwortlich",
    priority:     "Priorität",
    date:         "Datum",
    time:         "Zeit",
    total:        "Gesamt",
    notes:        "Notizen",
    invoice:      "Rechnung",
    group:        "Gruppe",
    type:         "Typ",
    rate:         "Rate",
    balance:      "Saldo",
    amount:       "Betrag",
    currency:     "Währung",
    name:         "Name",
    email:        "E-Mail",
    phone:        "Telefon",
    address:      "Adresse",
    country:      "Land",
    today:        "Heute",
    other:        "Sonstiges",
    none:         "Keine",
    unassigned:   "Nicht zugewiesen",
    inHouse:      "Im Haus",
    readyRoom:    "Bezugsfertiges Zimmer",
    noReadyRoom:  "Kein bezugsfertiges Zimmer",
  },

} as const;

export default dePmsCommon;
